
const servicesId = {
  hotels: 1,
  transfers: 2,
  flights: 4,
  insurances: 7,
  tours: 20
}

export default servicesId